<template>
    <div class="wui-container download">
        <img class="logo" src="@/assets/img/app-logo.png" alt="logo" />
        <p class="slogan">{{ $t("一个有灵魂的租房平台") }}</p>
        <p class="desc">{{ $t("无中介国际化社交") }}</p>
        <div class="btn-download" @click="$downloadApp">
            {{ $t("立即下载") }}
        </div>
    </div>
</template>

<script>
import { initWechatJSSDK } from "@/assets/wechat.js";

export default {
    components: {},
    data() {
        return {};
    },
    created(){
      this.handleAutoDownload();
    },
    mounted() {
        initWechatJSSDK({
            title: "Wellcee · Lifestyle",
            desc: this.$t("Wellcee的小伙伴们分享了好多有趣的故事和瞬间呢"),
            imgUrl: "https://qnimg1.wellcee.com/app.png",
        });
    },
    methods: {
        //校验为房东短信短链直接打开
        handleAutoDownload() {
            const { path, query } = this.$route;
            if (path === '/d' && query.p === 'm') {
               this.$downloadApp();
            }
        }
    },
};
</script>

<style scoped>
.download {
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 100%;
    background-image: url(../../assets/img/download-bg.jpg);
    background-size: cover;
    background-position: center;
    padding-top: 100px;
    color: #ffffff;
}
.logo {
    height: 108px;
}
.slogan {
    font-size: 23px;
    line-height: 20px;
    margin: 30px 0;
}
.desc {
    font-size: 18px;
    line-height: 20px;
    margin: 0;
}
.btn-download {
    margin-top: 100px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 186px;
    height: 55px;
    border: 1px solid #ffffff;
    box-sizing: border-box;
    border-radius: 10px;

    font-weight: 600;
    font-size: 20px;
    color: #ffffff;
}
</style>
